<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Cantine Colgin</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando il proprietario di LVMH Bernard Arnault si interessa a qualcosa, di solito è una buona cosa.
                        Di proprietà (ben il 60%) dal 2017 del colosso del lusso, Colgin Cellars è la più recente di Arnault
                        acquisizione al suo arco già ben teso. L'aggiunta della cantina cult della Napa Valley
                        completa la serie di accordi con Arnault nel settore vinicolo che Arnault ha concluso nel corso del 2017.
                    </div>

                    <div class="howto-title2">LVMH significa una cosa sicura</div>
                    <div class="howto-text">
                        Non è un segreto che Arnault sia un amante delle cose belle della vita. Già il suo portafoglio di vini
                        ospita pesi massimi come Krug, Clos des Lambrays e Château d'Yquem. E le cantine Colgin
                        sembrava essere il pezzo mancante del puzzle della sua azienda vinicola della Napa Valley (LVMH possiede anche Chandon
                        California e Newton per citarne solo due). Arnault è famoso per credere che l'eredità fa il
                        marchio, quindi come è stato così sedotto da un'azienda vinicola californiana che era stata fondata solo nel
                        1992?
                    </div>

                    <div class="howto-title2">Una strategia semplice che offre un ROI eccezionale</div>
                    <div class="howto-text">
                        La risposta sta senza dubbio in Ann Colgin &amp; La strategia di marketing di Joe Wender che li vede
                        specializzati in piccole produzioni (2.600-2.800 casse all'anno), rosso ultra premium artigianale
                        vini. Questi vengono poi venduti solo a una manciata di ristoranti e 8.000 clienti selezionati in molto
                        piccole quantità (da tre a sei bottiglie per cliente). Circa il 70% dei loro clienti lo sono
                        mailing list (con altri 3.000 candidati in lista d'attesa). Il restante 30% viene venduto a
                        ristoranti in tutto il mondo, con solo pochi casi trattenuti per la biblioteca personale della tenuta.
                        Questa strategia ha funzionato bene per Colgin e ha conferito al suo vino lo status di culto che ha catturato
                        L'occhio di Arnault (per non parlare del suo portafoglio).
                    </div>

                    <div class="howto-title2">Sigillo di approvazione di Parker</div>
                    <div class="howto-text">
                        Fortunatamente, molto poco è cambiato alla Colgin Cellars da quando Arnault è diventato la maggioranza
                        azionista. Il vino riceve costantemente punteggi incredibilmente alti, in particolare dal guru del vino Robert
                        Parker che ha un'enorme influenza negli Stati Uniti (infatti, Parker ha descritto la proprietà IX di Colgin come
                        “il più vicino al Nirvana viticolo che abbia mai visto”). Recensioni entusiastiche, un investitore importante e
                        un prodotto superlativo con una distribuzione minuscola? Cosa c'è che non va?
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Colgin Cellars</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn sich LVMH-Eigentümer Bernard Arnault für etwas interessiert, ist das normalerweise eine gute Sache.
                        Colgin Cellars ist seit 2017 (zu 60 %) im Besitz des Luxusgüterriesen und ist Arnaults jüngstes Unternehmen
                        Ergänzung zu seinem bereits gut gespannten Bogen. Die Hinzufügung des Kultweinguts Napa Valley
                        vervollständigt Arnaults Reihe von Weingütergeschäften, die Arnault im Laufe des Jahres 2017 abgeschlossen hat.
                    </div>

                    <div class="howto-title2">LVMH bedeutet eine sichere Sache</div>
                    <div class="howto-text">
                        Es ist kein Geheimnis, dass Arnault ein Liebhaber der schönen Dinge im Leben ist. Sein Weinportfolio bereits
                        beherbergt Schwergewichte wie Krug, Clos des Lambrays und Château d’Yquem. Und Colgin Cellars
                        schien das fehlende Teil seines Weingut-Puzzles im Napa Valley zu sein (LVMH besitzt auch Chandon).
                        Kalifornien und Newton, um nur zwei zu nennen). Arnault ist berühmt für seine Überzeugung, dass das Erbe das macht
                        Marke, wie konnte er sich so von einem kalifornischen Weingut verführen lassen, das erst 2010 gegründet wurde?
                        1992?
                    </div>

                    <div class="howto-title2">Eine einfache Strategie mit hervorragendem ROI</div>
                    <div class="howto-text">
                        Die Antwort liegt zweifellos in Ann Colgin &amp; Joe Wenders Marketingstrategie, die sie sieht
                        Spezialisiert auf kleine Produktionen (2.600–2.800 Kisten pro Jahr) und handgefertigte Ultra-Premium-Rotweine
                        Weine. Diese werden dann nur an eine Handvoll Restaurants und 8.000 ausgewählte Kunden in ganz Europa verkauft
                        kleine Mengen (ca. drei bis sechs Flaschen pro Kunde). Rund 70 % ihrer Kunden sind es
                        Mailingliste (mit weiteren 3.000 Hoffnungsträgern auf der Warteliste). Die restlichen 30 % werden verkauft
                        Restaurants weltweit, wobei nur wenige Kisten für die persönliche Bibliothek des Anwesens zurückbehalten wurden.
                        Diese Strategie hat bei Colgin gut funktioniert und ihrem Wein den Kultstatus verliehen, der sich durchgesetzt hat
                        Arnaults Auge (ganz zu schweigen von seiner Brieftasche).
                    </div>

                    <div class="howto-title2">Parkers Gütesiegel</div>
                    <div class="howto-text">
                        Glücklicherweise hat sich bei Colgin Cellars kaum etwas geändert, seit Arnault die Mehrheit übernommen hat
                        Aktionär. Der Wein erhält ständig unglaublich hohe Bewertungen, insbesondere von Wein-Guru Robert
                        Parker, der in den USA enormen Einfluss hat (tatsächlich hat Parker Colgins IX-Anwesen als beschrieben).
                        „so nah am Weinbau-Nirvana, wie ich es noch nie gesehen habe“). Begeisterte Kritiken, ein Schwergewichtsinvestor und
                        ein Produkt der Superlative mit einer winzigen Verbreitung? Was kann man nicht mögen?
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Caves Colgin</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quand Bernard Arnault, propriétaire de LVMH, s'intéresse à quelque chose, c'est généralement une bonne chose.
                        Détenu (enfin à 60%) depuis 2017 par le géant du luxe, Colgin Cellars est le plus récent d'Arnault.
                        acquisition à son arc déjà bien tendu. L'ajout du domaine viticole culte de Napa Valley
                        complète la série d'offres de domaines viticoles qu'Arnault a conclues tout au long de 2017.
                    </div>

                    <div class="howto-title2">LVMH signifie une valeur sûre</div>
                    <div class="howto-text">
                        Ce n'est un secret pour personne qu'Arnault est un amoureux des belles choses de la vie. Son portefeuille de vins déjà
                        abrite des poids lourds tels que Krug, Clos des Lambrays et Château d'Yquem. Et les caves Colgin
                        semblait être la pièce manquante de son puzzle de vignoble de Napa Valley (LVMH possède également Chandon
                        Californie et Newton pour n'en citer que deux). Arnault est célèbre pour croire que le patrimoine fait la
                        marque, alors comment a-t-il été séduit par un domaine viticole californien qui n'avait été fondé qu'en
                        1992?
                    </div>

                    <div class="howto-title2">Une stratégie simple offrant un excellent retour sur investissement</div>
                    <div class="howto-text">
                        La réponse réside sans aucun doute dans Ann Colgin &amp; La stratégie marketing de Joe Wender qui les voit
                        se spécialisent dans la petite production (2 600 à 2 800 caisses par an), le rouge ultra-premium artisanal
                        vins. Ceux-ci ne sont ensuite vendus qu'à une poignée de restaurants et 8 000 clients sélectionnés dans des
                        petites quantités (environ trois à six bouteilles par client). Environ 70 % de leurs clients sont
                        liste de diffusion (avec encore 3 000 espoirs sur la liste d'attente). Les 30 % restants sont vendus à
                        restaurants du monde entier, avec seulement quelques caisses conservées pour la bibliothèque personnelle du domaine.
                        Cette stratégie a bien fonctionné pour Colgin et a donné à son vin le statut de culte qui a attiré
                        L'oeil d'Arnault (sans parler de son portefeuille).
                    </div>

                    <div class="howto-title2">Sceau d'approbation de Parker</div>
                    <div class="howto-text">
                        Heureusement, très peu de choses ont changé chez Colgin Cellars depuis qu'Arnault est devenu majoritaire
                        actionnaire. Le vin reçoit constamment des notes incroyablement élevées, notamment du gourou du vin Robert
                        Parker qui a une énorme influence aux États-Unis (en fait, Parker a décrit le domaine IX de Colgin comme
                        "aussi proche du nirvana viticole que je n'en ai jamais vu"). Des critiques élogieuses, un gros investisseur et
                        un produit superlatif avec une petite distribution? Qu'est-ce qu'il ne faut pas aimer ?
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Colgin Cellars</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When LVMH owner Bernard Arnault takes an interest in something, usually it is a good thing.
                        Owned (well, 60%) since 2017 by the luxury goods giant, Colgin Cellars is Arnault’s most recent
                        acquisition to his already well-strung bow. The addition of the cult Napa Valley winery
                        completes Arnault string of wine estate deals that Arnault made throughout 2017.
                    </div>

                    <div class="howto-title2">LVMH means a sure thing</div>
                    <div class="howto-text">
                        It is no secret that Arnault is a lover of the finer things in life. His wine portfolio already
                        houses heavyweights such as Krug, Clos des Lambrays and Château d’Yquem. And Colgin Cellars
                        seemed to be the missing piece of his Napa Valley winery puzzle (LVMH also own Chandon
                        California and Newton to name but two). Arnault is famous for believing that heritage maketh the
                        brand, so how has he become so seduced by a Californian winery that had only been founded in
                        1992?
                    </div>

                    <div class="howto-title2">A simple strategy offering superb ROI</div>
                    <div class="howto-text">
                        The answer undoubtedly lies in Ann Colgin &amp; Joe Wender’s marketing strategy that sees them
                        specialise in small production (2,600-2,800 cases annually), hand-crafted ultra-premium red
                        wines. These are then only sold to a handful of restaurants and 8,000 selected clients in very
                        small quantities (around three to six bottles per client). Around 70% of their clients are
                        mailing list (with another 3,000 hopefuls on the waiting list). The remaining 30% is sold to
                        restaurants worldwide, with just a few cases being kept back for the estate’s personal library.
                        This strategy has worked well for Colgin, and has given her wine the cult status that caught
                        Arnault’s eye (not to mention his wallet).
                    </div>

                    <div class="howto-title2">Parker’s seal of approval</div>
                    <div class="howto-text">
                        Happily, very little has changed at Colgin Cellars since Arnault became the majority
                        shareholder. The wine constantly receives incredibly high scores, notably from wine guru Robert
                        Parker who has enormous influence in the US (in fact, Parker has described Colgin’s IX estate as
                        “as close to viticultural Nirvana as I’ve ever seen”). Rave reviews, a heavyweight investor and
                        a superlative product with a tiny distribution? What’s not to like?
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColginCellars",
    head: {
        title: 'Colgin Cellars | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover Colgin Cellars, a renowned Napa wine producer known for its exceptional wine blends made from the finest grapes grown in California\'s wine country. Experience the exquisite taste and smooth finish of these hand-crafted wines today.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
